function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrafficSignTrafficLightsFreeRightTurnEu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Traffic_x5F_Lights_x5F_Free_x5F_Right_x5F_Turn_x5F_EU",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#13D246"
    },
    points: "54.882,6.389 41.118,17.989 58.827,39 6,39 6,57 58.827,57 41.118,78.01 54.882,89.611  89.954,48  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M54.882,6.389L89.954,48L54.882,89.611L41.118,78.01L58.827,57H6V39h52.827L41.118,17.989 L54.882,6.389 M54.881,4.389c-0.455,0-0.913,0.154-1.288,0.471L39.829,16.46c-0.406,0.342-0.659,0.831-0.704,1.359 c-0.045,0.529,0.122,1.053,0.464,1.459L54.526,37H6c-1.105,0-2,0.895-2,2v18c0,1.105,0.895,2,2,2h48.526L39.589,76.721 c-0.712,0.845-0.604,2.106,0.24,2.818l13.764,11.602c0.362,0.305,0.819,0.471,1.289,0.471c0.057,0,0.113-0.002,0.17-0.007 c0.529-0.045,1.018-0.298,1.359-0.704l35.072-41.611c0.628-0.745,0.628-1.833,0-2.578L56.411,5.1 C56.016,4.63,55.45,4.389,54.881,4.389L54.881,4.389z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrafficSignTrafficLightsFreeRightTurnEu);
export default __webpack_public_path__ + "static/media/icon-traffic_sign_traffic_lights_free_right_turn_eu.e3d4221f17529758b84ebe9a3dc4f348.svg";
export { ForwardRef as ReactComponent };